import React from 'react'
import { DocumentDownload } from 'iconsax-react'
import { useTheme } from '@mui/material'

import Tooltip from '../../../../atoms/Tooltip'

import useStyles from './styles'

type DownloadButtonProps = {
  onClick: () => void
}

const DownloadButton: React.FC<DownloadButtonProps> = ({ onClick }) => {
  const theme = useTheme()

  const classes = useStyles()

  return (
    <Tooltip
      title='Download File'
      placement='right-start'
      classes={{ tooltipPlacementRight: classes.tooltip }}
    >
      <div
        onClick={e => {
          e.stopPropagation()
          onClick()
        }}
        className={classes.root}
      >
        <DocumentDownload size={theme.size.sm} color='#F5F6F8' />
      </div>
    </Tooltip>
  )
}

export default DownloadButton
